const Arrow10x20 = () => (
  <svg
    width="10"
    height="20"
    viewBox="0 0 10 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.63557 5.05085C4.12753 6.73388 5.62026 8.41612 7.20001 10.1971C7.0581 10.3106 6.93975 10.3795 6.84979 10.4808C4.83408 12.7519 2.82104 15.026 0.808637 17.301C0.249397 17.9333 0.209548 18.737 0.703846 19.3074C1.17565 19.8519 1.91236 19.8226 2.45339 19.2129C4.82586 16.5397 7.1953 13.8631 9.56073 11.1819C10.1508 10.513 10.1454 9.76431 9.5504 9.09042C7.19227 6.41992 4.83099 3.75301 2.46682 1.08927C1.91271 0.46493 1.17214 0.435067 0.689859 0.995629C0.210601 1.55277 0.251013 2.34549 0.798446 2.9711C1.40794 3.66755 2.02207 4.35884 2.63557 5.05085Z"
    />
  </svg>
);

export default Arrow10x20;
